import { APLLoadingPage } from 'legacy/hpscoutso/components/pages/aplCommon/APLLoadingPage'
import { APLAMSPageLayout } from 'legacy/hpscoutso/layout/aplPageLayout/APLAMSPageLayout'
import { useContext, useEffect, useMemo, useState } from 'react'

import logger from 'core/utils/Logger'
import { showError } from 'onboarding/classes/services/notification'
import { LanguageContext } from 'onboarding/context/LanguageContext'
import { aplService } from 'onboarding/services/aplService'

import { AMSNoAccess } from './components/noAccess/AMSNoAccess'
import { PageContent } from './components/pageContent/PageContent'

export const AmsLATAMPartnersSearch = () => {
  const { translationIsLoading } = useContext(LanguageContext)
  const [isCheckingAccess, setIsCheckingAccess] = useState(true)
  const [isAllowed, setIsAllowed] = useState(false)
  const isLoading = isCheckingAccess || translationIsLoading

  const content = useMemo(() => {
    switch (true) {
      case isLoading:
        return <APLLoadingPage />
      case !isAllowed:
        return <AMSNoAccess />
      default:
        return <PageContent />
    }
  }, [isLoading, isAllowed])

  useEffect(() => {
    const checkAccess = async () => {
      setIsCheckingAccess(true)
      try {
        const hasAccess = await aplService.checkAccessAmsSearch()
        setIsAllowed(hasAccess)
      } catch (e: any) {
        logger.error(e)
        showError(e.message || 'System error')
      } finally {
        setIsCheckingAccess(false)
      }
    }
    checkAccess()
  }, [])

  return <APLAMSPageLayout>{content}</APLAMSPageLayout>
}
